import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material';

const BoxData = ({
    data = '상위 25.2%',
    variant = 'default',
    size = 'medium',
    disabled = false,
    onClick,
    sx = {},
    ...props
}) => {
    const theme = useTheme();
    const baseStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        padding: size === 'small' ? '4px 8px' : '4px 10px',
        borderRadius: '8px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        position: 'relative',
        height: '22px',
        '&:hover': onClick
            ? {
                opacity: 0.8,
            }
            : {},
        ...sx,
    };

    const variantStyles = {
        default: {
            backgroundColor: theme.palette.figma.white[5],
            border: `1px solid ${theme.palette.figma.white[20]}`,
            '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                borderRadius: '8px',
                pointerEvents: 'none',
            },
        },
        onecolor: {
            backgroundColor: 'transparent',
            border: `1px solid ${theme.palette.figma.iconWhite}`,
            '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                borderRadius: '8px',
                opacity: 0.2,
                zIndex: 1,
            },
        },
    };

    const textStyles = {
        fontSize: size === 'small' ? '10px' : '12px',
        fontWeight: 500,
        letterSpacing: '-0.36px',
        whiteSpace: 'nowrap',
        position: 'relative',
        zIndex: 2,
        ...(variant === 'default'
            ? {
                color: theme.palette.figma.white[80],
            }
            : {
                color: theme.palette.figma.buttonText,
            }),
    };

    const disabledStyles = disabled
        ? {
            opacity: 0.5,
            cursor: 'not-allowed',
            '&:hover': {
                opacity: 0.5,
            },
        }
        : {};

    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    return (
        <Box
            sx={{
                ...baseStyles,
                ...variantStyles[variant],
                ...disabledStyles,
            }}
            onClick={handleClick}
            {...props}
        >
            <Typography sx={textStyles}>{data}</Typography>
        </Box>
    );
};

export default BoxData;
